var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Disable discounts'),"value":_vm.value.discounts_disabled,"disabled":_vm.isLoading || _vm.disabled},on:{"input":_vm.updateDiscountsStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }